import React from 'react';
import Layout from '../../components/Layout';
import Basket from './Basket';
import { getPagePresentationKeys } from '../../actions/page';
import getWrappings from '../../actions/wrapping';

const pageName = 'basket';

async function action({ store }) {
  const {
    basket: { id },
  } = store.getState();
  const {
    byName: {
      [pageName]: { pageTitle, pageDescription },
    },
  } = await store.dispatch(getPagePresentationKeys({ pageName }));

  store.dispatch(getWrappings());

  return {
    chunks: ['basket'],
    title: pageTitle || 'Basket',
    description: pageDescription,
    component: (
      <Layout footerBar>
        <Basket id={id} />
      </Layout>
    ),
  };
}

export default action;
